import TextEditor from '../../components/textEditor/TextEditor'

const PricingAndPayment = () => {
    return (
        <TextEditor tag_name="pricing_payment" />
    )
}

export default PricingAndPayment